var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_1959)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.57143C18 8.09828 17.616 7.71429 17.1429 7.71429C10.9886 7.71429 6 12.7029 6 18.8571C6 25.007 10.993 30 17.1429 30C23.2971 30 28.2857 25.0114 28.2857 18.8571C28.2857 18.384 27.9017 18 27.4286 18H18V8.57143ZM16.2857 9.46722V18.8571C16.2857 19.3302 16.6697 19.7142 17.1429 19.7142H26.5327C26.1 24.5194 22.061 28.2857 17.1429 28.2857C11.9393 28.2857 7.71429 24.0608 7.71429 18.8571C7.71429 13.9391 11.4806 9.89971 16.2857 9.46722ZM20.5714 6C20.0983 6 19.7143 6.38399 19.7143 6.85714V15.4286C19.7143 15.6566 19.8052 15.8751 19.9663 16.0362C20.1283 16.1965 20.3468 16.2865 20.5749 16.2857L29.1463 16.2505C29.6185 16.2488 30 15.8657 30 15.3934C30 10.2103 25.7761 6.00005 20.5715 6.00005L20.5714 6ZM21.4286 7.76136C25.0012 8.15492 27.8424 10.9825 28.2387 14.5396L21.4286 14.568V7.76136Z",
    fill: "#414042",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_1959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEDashboard);
export default __webpack_public_path__ + "static/media/e-dashboard.6cf0f98f3e26a85f9e3bc0e2c867b704.svg";
export { ForwardRef as ReactComponent };